export default __webpack_public_path__ + "static/media/puls.c2560065.png";